import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const LoansLayout = ({
  children,
  title,
  centerTitleOnMobile,
  withBack,
  renderFilter,
  hasHeader,
  onCloseClick,
}) => {
  const history = useHistory();
  const renderCloseButton = () => (
    <div className="d-flex d-md-none flex-row align-items-end justify-content-end mb-4">
      <span
        style={{ zIndex: '1001' }}
        className="me-2"
        role="button"
        tabIndex="0"
        onKeyPress={onCloseClick}
        onClick={onCloseClick}>
        <img src="./assets/images/close.svg" alt="close" />
      </span>
    </div>
  );
  return (
    <div className="container p-0">
      {hasHeader && (
        <>
          {renderCloseButton()}

          {/* mobile layout */}
          <div className="d-block d-md-none mt-5 mb-4 w-100" style={{ padding: '0 0.75rem' }}>
            {title && (
              <div className="col-md-3 col-sm-12 d-flex flex-row flex-fill align-items-center h-auto px-4">
                {withBack && (
                  <i
                    className="icon-arrow-back-navigation text-f4 me-3 cursor-pointer"
                    onClick={history.goBack}
                    role="button"
                    onKeyDown={null}
                    tabIndex={-1}
                    aria-label="Back"
                  />
                )}
                <p className={`${centerTitleOnMobile ? 'text-center' : ''} text-f3`}>
                  <b>{title}</b>
                </p>
              </div>
            )}
            {renderFilter && (
              <div className="col-12 col-md-9">{renderFilter && renderFilter()}</div>
            )}
          </div>

          {/* browser layout */}
          <div className="d-none d-md-block mt-5 mb-4 row" style={{ padding: '0 0.75rem' }}>
            {renderFilter && (
              <div className="col-12 col-md-9 ">{renderFilter && renderFilter()}</div>
            )}
          </div>
        </>
      )}
      {/* mobile layout */}
      <div
        className={`d-block d-md-none w-100 h-100 hide-scroll overflow-scroll pb-5 ${
          hasHeader ? '' : 'mt-5'
        }`}
        style={{ padding: '0 0.75rem' }}>
        {children}
      </div>

      {/* browser layout */}
      <div
        className={`d-none d-md-flex row ${hasHeader ? '' : 'mt-5'}`}
        style={{ padding: '0 0.75rem' }}>
        {children}
      </div>
    </div>
  );
};

export default LoansLayout;

LoansLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  title: PropTypes.string,
  withBack: PropTypes.bool,
  renderFilter: PropTypes.func,
  hasHeader: PropTypes.bool,
  centerTitleOnMobile: PropTypes.bool,
  onCloseClick: PropTypes.func,
};
LoansLayout.defaultProps = {
  title: '',
  withBack: null,
  renderFilter: null,
  hasHeader: true,
  centerTitleOnMobile: false,
  onCloseClick: null,
};
